<template>
  <div>
    <b-row>
      <b-col lg="4">
        <b-form-group>
          <label for="nombre">Código de lista</label>
          <b-form-input
            id="codigo-lista"
            name="codigo-lista"
            type="text"
            maxlength="6"
            v-model="selectedListas.codigo"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="8">
        <b-form-group>
          <label for="nombre">Descripción</label>
          <b-form-input
            id="nombre"
            name="nombre"
            type="text"
            v-model="selectedListas.lista"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="row justify-content-center">
        <b-button variant="primary" size="sm" @click="nuevaLista">
          <i class="fa fa-floppy-o"></i> Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: "modal-listas",
  data() {
    return {};
  },
  methods: {
    async nuevaLista() {
      if (this.accionLista == "Crear") {
        this.filtroListas.id_control = this.selectedListas.id_control;
        await this.crearLista();
        await this.getListas();
      } else {
        this.filtroListas.id_control = this.selectedListas.id_control;
        await this.actualizarLista();
        await this.getListas();
      }
      this.$emit("vModalListas", false);
      this.resetSelectedLista();
    },
    ...mapActions("administracion", ["getListas", "crearLista", "actualizarLista"]),
    ...mapMutations("administracion", [
      "resetSelectedLista",
    ])
  },
  computed: {
    ...mapState("administracion", ["selectedListas", "accionLista", "filtroListas"]),
  },
};
</script>